import type { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import type { RedoStorefrontConfig } from "../config";

/**
 * Activation gate for the EDD renderer. Import-free so the bootstrap can
 * statically import it; `getAutocheck` runs only once the cheap guards pass.
 */
export async function shouldInitializeEstimatedDeliveryDate(deps: {
  blockRedo: boolean | undefined;
  storefrontType: RedoStorefrontConfig["type"] | undefined;
  isOnTargetPage: () => boolean;
  getAutocheck: () => Promise<WidgetAutocheck | undefined>;
}): Promise<boolean> {
  const { blockRedo, storefrontType, isOnTargetPage, getAutocheck } = deps;

  if (blockRedo) {
    return false;
  }
  if (storefrontType !== "commercecloud") {
    return false;
  }
  if (!isOnTargetPage()) {
    return false;
  }

  const autocheck = await getAutocheck();
  return !!autocheck?.checkoutDeliveryEstimates?.enabled;
}
